<template>
	<v-container fluid>
		<v-row
			justify = "center"
		>
			<v-col
				xl 	 = "10"
				lg 	 = "12"
				md 	 = "12"
				sm 	 = "12"
				xs 	 = "12"
				cols = "12"
			>
				
			
				<v-card outlined>
					<v-card-title
						class  = "justify-center body-1 secondary pa-1 white--text"
						
					>	
						<v-icon 
							small 
							color  = "white"
							class  = "ml-1"
							@click = "$router.back()"
						>
							mdi-arrow-left-circle
						</v-icon>

						<v-spacer></v-spacer>
						<v-icon 
							small 
							color  = "primary"
							class  = "mx-2"
						>
							{{ head.icon_title }}
						</v-icon>
						<span 
							
						>
							{{ head.title }}
						</span>
						<v-spacer></v-spacer>

					</v-card-title>
					<v-spacer></v-spacer>
					<v-card-text
						:class =  "head.class_text"
					>				
						<v-row
							dense
						>
							<v-col 
								xl 	   = "2"
								lg 	   = "2"
								md 	   = "3"
								sm 	   = "3"
								xs 	   = "3"
								cols   = "3"
								v-show = "show.add_contact"
							>
								<v-card >
									<v-card-title
										class = "pa-1 pl-2 secondary body-2 white--text"
									>
										<v-icon
											x-small
											color = "white"
											class = "mx-1"
										>
											mdi-form-select
										</v-icon>
										{{ $ml.get('options') }}
									</v-card-title>
									<v-card-text class = "pa-1 pt-0">
										<v-list dense>

			
											<v-list-item-group
											 	color = "primary"
											>
												<template
													v-for = "(btn_contact, btn_index) of get_type_contacts"
												>	
													<v-card outlined
														:key = "'btn_contact' + btn_index"
													>

													<v-list-item 
														class  = "primary"
														:key   = "btn_index"	
														@click = "redirect(btn_contact)"				
													>				
													 	<v-list-item-icon
													 		class = "mx-0"
													 	>
											            	<v-icon 
											            		small
											            		color  = "white"
											            		v-text = "btn_contact.icon"
											            	></v-icon>
											          	</v-list-item-icon>													
														<v-list-item-title
															class  = "white--text"
															v-text = "btn_contact.title"
														></v-list-item-title>
													</v-list-item>
												</v-card>
												</template>
											</v-list-item-group>
										</v-list>
									</v-card-text>
								</v-card>
										
							</v-col>
							<v-col>
								<v-toolbar						    		
						    		dense
						    		height = "25"
						    		class  = "secondary white--text"
						    	>
					    			<v-icon
										small
										color = "white"
										class = "mr-1"
									>
										mdi-view-list
									</v-icon>
						    		<v-toolbar-title  
						    			class = "body-2"
						    		>	
						    			{{ head.title_table }}
						    		</v-toolbar-title>
						    		<v-spacer></v-spacer>
						    		<v-btn-toggle
						    			v-show = "show.selecteds"
						    		>
						    			
							    		<template
							    			v-for = "(item_option, idx_option) of options_backup"
							    		>	
							    			<v-tooltip
							    				bottom
												:key="'tooltip'+idx_option"
								    			v-if   = "item_option.type == 'btn'"
							    			>
							    				
								    			<template v-slot:activator = "{ on }">							    			
								    			<v-btn
								    				x-small
								    				v-on   = "on"
								    				:key   = "idx_option"
								    				:color = "item_option.color" 
								    			>
								    				<v-icon
								    					x-small						    					
								    				>
								    					{{ item_option.icon }}
								    				</v-icon>
								    			</v-btn>
								    			</template>
								    			<span>
								    				{{ $ml.get(item_option.text) }}
								    			</span>
							    			</v-tooltip>
							    			<v-menu 
							    				bottom 
												:key="'men'+idx_option"
												offset-y 
												:close-on-content-click = "true"
									    		v-else-if 	 	= "item_option.type == 'file'"
							    			>	
												
								    			<template v-slot:activator = "{ on : menu}">									    					

								    				<v-tooltip
								    					bottom									    				
								    				>
							    						<template 
							    							v-slot:activator = "{ on : tooltip}"
							    						>		
									    				
											    			<v-btn
											    				x-small
											    				:key    = "idx_option"
					    										v-on 	= "{...tooltip, ...menu}"	
											    				:color  = "item_option.color" 
											    				
											    			>
											    				<v-icon
											    					x-small						    					
											    				>
											    					{{ item_option.icon }}
											    				</v-icon>
											    			</v-btn>
											    		</template>
											    		<span>
								    						{{ $ml.get(item_option.text) }}
											    			
											    		</span>
											    	</v-tooltip>
							    				</template>
										    		<!-- hide-input -->
									    		<v-list 
									    			dense
									    			class = "pa-0"

									    		>
									    			<v-list-item>
									    				<v-list-item-content
											    			class = "pa-0"

									    				>
									    					 <v-list-item-title>
									    					 	
									    			
										    			<v-file-input 
											    			dense
											    			hide-details
											    			class 		 	= "pa-0 success pa-0"
											    			@change 	 	= "actions(item_option.action)"
											    			v-model 	 	= "info_import"
											    			:prepend-icon 	= "item_option.icon"
											    			placeholder 	= "import"
										    			>								    			
											    			<!-- style 			= "font-size: 10px; height: 20px;" -->
										    			</v-file-input>
									    					 </v-list-item-title>
									    				</v-list-item-content>
									    			</v-list-item>
									    		</v-list>
							    			</v-menu>
							    		</template>
						    		</v-btn-toggle>
						    	</v-toolbar>
								<v-divider></v-divider>
								<v-data-table
									dense
								    fixed-body
								    fixed-header
								   	:show-select 		 = "show.selecteds"
									:headers 			 = "header_table"
									:items 				 = "render_list"
									class 				 = "elevation-5"
								   	loading-text 		 = "Loading... Please wait"
								   	v-model 			 = "contacts_selecteds"
								   	:loading 			 = "loading"
								    item-key 			 = "index"
								    :height 			 = "layout_height + 'px'"
									:options.sync 		 = "options"
								   	:server-items-length = "total"
								   	:footer-props 		 = "{
								   		showFirstLastPage   : true,
								   		itemsPerPageOptions : [total],  // 15, 30
								   		showCurrentPage 	: true,
								   		itemsPerPageText 	: ''
								   	}"
								>
								    <!-- rowsPerPageText: [30] -->
								    <template v-slot:top >
								    	<v-row 
								    		no-gutters
								    	>
								    		<v-col
								    			cols = "12"
								    		>
								    			<searcher
													
													:info_to_component = "item_search"
													:info_to_component1 = "select_type_contact"
													:info_to_list  	   = "list"
													@receive_info	   = "listed = $event"
												></searcher>
								    		</v-col>
								    		<!-- <v-col>
								    			<v-select
								    				dense
								    				outlined
								    				hide-details
								    				small-chips
								    				class 		= "mt-1"
								    				v-model 	= "select_type_device"
								    				:items  	= "list_types_devices"
								    				:label  	= "$ml.get('type_device')"
								    				item-text 	=  "title"
								    				item-value 	= "key"
								    			></v-select>
								    				
								    		</v-col> -->
								    	</v-row>
								    </template>
								    
								    <template
					                    v-for = "(head, idx_head) of header_table"
					                    v-slot:[`header.${head.value}`]   = "{ header, index }"                            

					                >
					 					<span>
					                        {{ $ml.get(head.text) }}
					                    </span>
					 				</template>
								    <template
								    	v-for  = "(item_opt, idx_opt) of options_table"
								    	v-slot:[`item.${item_opt.slot}`] = "{ item, index }"
								    >
								    
								    	<v-btn
								    		small
								    		:key 	= "ID_notification + idx_opt"	
								    		:color 	= "item[item_opt.key] ? 'primary' : 'secondary'"
								    		@click 	= "actions(item_opt, item, index)"
								    	>
								    		{{ item[item_opt.key] ? $ml.get('on') : $ml.get('off')  }}
								    	</v-btn>
								    </template>

									<template 
										v-slot:item.actions = "{ item }"	
									>
										<v-btn-toggle mandatory>
											<v-btn
												x-small
												color  = "primary"
												@click = "redirect({
													info 	: item,
													local 	: 'settings_contact',
													url 	: 'settings_contact'
												})"
												v-show = "show.edit_contact" 
											>
												<v-icon
													x-small
													v-text = "'mdi-pencil'"
												></v-icon>
											</v-btn>	
											<v-btn
												x-small												
												color  = "error"
												@click = "actions('confirm_delete', item)"
												v-show = "show.delete_contact" 
											>
												<v-icon
													x-small
													v-text = "'mdi-delete'"
												></v-icon>
											</v-btn>							
										</v-btn-toggle>
									</template>

									
									
									
								</v-data-table>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
	import axios 	from 'axios'
	import EventBus from '@/event-bus'
	import searcher from "@/components/info/searcher.vue"

	export default{
		name 		: 'add_device',
		components  : {
			searcher,		
		}, // components
		data: (vm) => ({
			// table

			head 			: {
				title 			: vm.$ml.get("contacts"),
				icon_title 		: "mdi-contacts",
				title_table  	: vm.$ml.get('registered_contacts'),
				class_text 		: "pa-1"
			},
			header_table 	: [
				{ text: 'name', value: 'name' },
				{ text: 'cellphone', value: 'cellphone' },
				// { text: vm.$ml.get('email'), value: 'email' },
				{ text: 'type_of_contact', value: 'type_contact' },				
				// { text: vm.$ml.get('send_ws'), value: 'isWs' },
				{ text: 'send_telegram', value: 'isTelegram' },				
				// { text: vm.$ml.get('send_email'), value: 'isEmail' },		
				// { text: vm.$ml.get('state'), value: 'state' },			
				// { text: 'actions', value: 'actions' },				


			],
			options : { itemsPerPage: 30 },
			total 	: 0,
			list 	: [
				// {name : "test", isWs : true, isTelegram : false, isEmail : true, email : "test@email.com", state : true, id : 1}
			],
			listed 	: [
				// {name : "test", isWs : true, isTelegram : false, isEmail : true, email : "test@email.com", state : true, id: 1}
			],
			// sidebar 
			type_contacts: [
				{ 
					key  		: 'new_contact',
					title  		: vm.$ml.get("new_contact"), 
					color 		: 'primary', 
					enable 		: true, 
					btn_action 	: 'new_contact', 
					icon  		: 'mdi-account-box',
					local 		: "settings_contact",
					url 		: "new_contact",
					info 		: { "type" : "new" },
				},
				
			], 
			layout_height : 400,
			curren_route  : true,
			info_del 	  : null,
			loading  	  : false,
			item_search   : {
				key 		 : 'search',
				text 		 : 'search',
				placeholder  : 'device',
				list 		 : 'list_devices',
				key_list	 : 'name',
				text_list 	 : 'name',
				type 		 : 'field_searcher',
				key_search   : 'name',
				key_search_1 : 'deviceId',
				visible 	 : true,
				cols 		 : {
					col : 2,
				},
			},
			search 		  : '', 
			bus  		  : {},			
			permission 	  : {
				"roles": [1, 2]
			},
			options_backup : [
				{
					key 	: 'backup',
					type 	: 'btn',
					action  : 'backup',
					text 	: 'backup',
					icon 	: 'mdi-folder-upload',
					color 	: 'primary',
				},
				{
					key 	: 'restore_backup',
					type 	: 'file',
					action  : 'restore_backup',
					text 	: 'restore_backup',
					icon 	: 'mdi-file-import',
					color 	: 'success',
				},
				{
					key 	: 'del_devices',
					type 	: 'btn',
					action  : 'confirm_del_devices',
					text 	: 'delete_devices',
					icon 	: 'mdi-trash-can',
					color 	: 'error',
				},
			],
			contacts_selecteds: [],
			show 				: {
				select 	  		: false,
				selecteds 	 	: false,
				add_contact		: true,
				edit_contact 	: true,
				delete_contact 	: true,
			},
			info_import 		: null,
			select_type_contact	: "all",
			list_types_devices  : [
				{
					key 	: "all",
					title 	: "All", 
				},
				{ 
					key  		: 'IP_CAM',
					title  		: 'IP CAM',
				},
				{ 
					key  		: 'PERIPHERAL',
					title  		: 'PERIPHERALS', 
				}
			],
			ID_notification 	: "add_contact",
			options_table  		: [
				{
					key 	: "isWs",
					type 	: "switch",
					slot 	: "isWs",
					action 	: "update_is",
				},
				{
					key 	: "isEmail",
					type 	: "switch",
					slot 	: "isEmail",
					action 	: "update_is",
				},
				{
					key 	: "isTelegram",
					type 	: "switch",
					slot 	: "isTelegram",
					action 	: "update_is",
				},
				{
					key 	: "state",
					type 	: "switch",
					slot 	: "state",
					action 	: "update_is",
				},
			]
		}), // data

		created(){
			let modul = this.$store.getters["auth/permission"](this.$route.name || "contacts", "", "contacts");
			if (modul){// this.$Helper.current_auth_user(this.currentUser, this.permission)
				if (!modul.can_add) {
					this.show.add_contact  = false; 
				}else{
					this.show.add_contact  = true; 
				}
				if (!modul.can_edit) { // this.$router.currentRoute.name == 'contacts'
					this.show.edit_contact = false;
				}
				if (!modul.can_delete) {
					this.show.delete_contact = false;
				}
				if (modul.can_delete || modul.can_edit) {
					this.header_table.push({ text: this.$ml.get('actions'), value: 'actions', align: 'center' });
				}
			}
		}, // created

		watch: {
			options: {
				handler(){
					this.get_list();
				}, deep: true
			}, // options

		}, // watch 

		methods: {
			recive_info(val, from){

			}, // recive_info
			actions(act, item, opt){
				
				if (act == 'confirm_delete') {
					this.info_del = item;
					EventBus.$emit('notifications_modal', {
						type : 'confirm_delete',
						ID 	 : this.ID_notification,
					})
				}
				if (act == 'backup') {	
					this.actions_async('backup');
				}	
				if (act == 'restore_backup') {
					this.actions_async('restore_backup');
				}
				if (act == 'confirm_del_devices') {
					this.$EventBus.$emit('notifications_modal',{
						type : 'confirm_delete',
						ID 	 : this.ID_notification,
					});
				}else
				if (act == "update_is" || act.action == "update_is") {
					// console.log("update_is ", item, opt);
					item[act.key] = !item[act.key];
					this.update(item, opt);
				}
				
				
			}, // actions
			async actions_async(act){
				if (act == 'backup') {

				}
				if (act == 'restore_backup') {

				}

				if (act == 'delete_contacts'){

				}
			}, // actions async

			redirect({url, info, local }){				
				localStorage.setItem(local, JSON.stringify(info));
				this.$router.push({ name: url });
			}, // redirect			

			async get_list(page = 1, itemss = []){
				// const { itemsPerPage, page } = this.options;
				const api 	 = this.$URL + '/api/v1/contacts/?page=' + page;
				this.loading = true;
				
				await this.$axios.get(api).then( res => {
					// console.log(res, 'res get_list');
					if (res && res.data && res.data.rows &&  res.data.rows.length > 0) {

						let items 	= itemss;
						items 		= items.concat(res.data.rows);
						if (page == 1) {
							if (res.data.count) {
								this.total 	 = res.data.count;
							}else{
								this.total   = res.data.rows.length;
							}

						}

						if (res.data.pages > page) {
							page++;
							this.get_list(page, items);
						}else{

							this.render_list_contact(items)
						}
					}else{
						this.render_list_contact(itemss)
					}
					this.loading = false;

				}).catch( er => {
					this.loading = false;					
					console.log(er, 'Error get contacts');
				})


			}, // get list

			render_list_contact(items){
				if (items && items.length > 0) {
					
					items.sort(function(a,b){
					  // Turn your strings into dates, and then subtract them
					  // to get a value that is either negative, positive, or zero.
					  return    new Date(b.createdAt) - new Date(a.createdAt);
					});
					this.list 	 = [...items];
					this.listed  = [...items];
					
				}
			}, // render list device

			update(item, idx){
				if (item && item.id) {
					const api    = this.$URL + '/api/v1/contacts/' + item.id;
					this.loading = true;
					this.$axios.put(api, item).then( res => {
						this.loading = false;
						this.list.splice(this.list.indexOf(item), item);
						this.listed.splice(this.listed.indexOf(item), item)
					}).catch(er => {
						this.loading = false;
						console.log("Error update contact ", er)
					});
				}else{
					console.warn("Not found id to update contact : ", item)
				}
			}, // update

			del(item){
				if (item && item.id) {
					// console.log("CHECK LIST : *** ", this.list.indexOf(item), item)
					const api    = this.$URL + '/api/v1/contacts/' + item.id;
					this.loading = true;
					this.$axios.delete(api).then( res => {
						// console.log(res);
						this.list.splice(this.list.indexOf(item), 1);
						this.listed.splice(this.listed.indexOf(item), 1);
						// this.$store.commit("Devices/delete_device", {...item});
						// this.$Helper.set_local("list_devices", this.listed);
            			// this.$Format.update_list('devices', this.listed);

						/*EventBus.$emit('render_modules', {
							name : 'delete_device',
							associate: item,
						})*/
						EventBus.$emit('notifications_modal',{
							type: 'deleted'
						});
						if (this.info_del) {
							this.info_del = null;
						}
						this.loading = false;
						// EventBus.$off('notifications_modal');
					}).catch( er => {
						console.log("Error del contacts ", er);
						this.loading = false;					
						this.$EventBus.$emit('notifications_modal',{
							type 	: 'error',
							message : er
						})
					})
				}else{
					/*this.$EventBus.$emit('notifications_modal',{
						type    : 'warning',
						message : this.$ml.get('no_found_id_del') 
					});*/
				}
			}, // del

		}, // methods
		computed: {
			render_list: function(){
				if (this.select_type_contact != 'all') {
					let list_temp 	= this.list.filter(dev => {
							return dev.type == this.select_type_contact;
						})
					// console.log("this listed ", this.listed)
					if (list_temp && list_temp.length === 0) {
						return [];
					}else{
						return list_temp;

					}
				}
				return this.listed;
			}, // render list

      		currentUser(){
      			return this.$store.state.auth.user;      			
      		}, // currentUser
			get_type_contacts(){
				return this.type_contacts.filter(contact => contact.enable == true)
			},

		}, // computed

		mounted(){
			let temp_bus = 'notifications_modal' + this.ID_notification;
			EventBus.$on(temp_bus, this.bus[temp_bus] =  (action) =>{
				
				if (action) {
					const info_dl = this.info_del;
					if (this.contacts_selecteds && this.contacts_selecteds.length > 0 && !info_del) {
						this.actions_async('delete_contacts');
					}else{
						this.del(info_dl);
					}
					// EventBus.$off('render_modules');
				}
			});

			
	
		}, // mounted
		beforeDestroy(){
			let vm = this;
			for (let iter in vm.bus){
				if (vm.bus[iter]) {
					EventBus.$off(iter, vm.bus[iter]);
				}
			}
			// console.log("clear bus add device");
			
		}, // before destroy
	};
</script>